import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'react-bootstrap';
import SchemeService from '../../services/SchemeService';
import ProductService from '../../services/ProductService';
import tableRequest from '../../models/tableRequest.js';
import { Dropdown } from 'primereact/dropdown';
import MessageComponent from '../../template/Message';
import Loaders from '../../template/Loaders';
import $ from 'jquery';

// Scheme Configuration 
export default class SchemeConfiguration extends Component {

    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            updateLoader:false,
            buttonLabel: 'Submit',
            sortOrder:'',
            SchemeId: 0,
            ProductId: 0,
            formError: {
                SchemeId: null,
                ProductId: null
            },
            SchemeDDL: [],
            ProductDDL: [],
            formHeading: 'Add Scheme Configuration',

            sales: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found'
        }

        //this.brandTemplate = this.brandTemplate.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.activeTemplate = this.activeTemplate.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.SchemeService = new SchemeService();
        this.ProductService = new ProductService();
        this.tblResponse = new tableRequest();

        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.openDialog = this.openDialog.bind(this);

        this.onSort = this.onSort.bind(this);

    }
    //trigger api function on page call
    componentDidMount() {
        setTimeout(() => {

            this.GetSchemesConfiguration();
            this.GetSchemesDDL();
            this.GetProductDDL();
        }, 1000);
        $('.p-column-title').on('click', function(){
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });
    }

    // call on Page
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.GetSchemesConfiguration();
        }, 250);
    }

    // search filter table
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetSchemesConfiguration();
    }

    // open dialog
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }

    // set lazy loading values
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = '1';
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }

    // get scheme Drop down list
    GetSchemesDDL() {
        this.SchemeService.GetSchemeDDL().then(data => {
            const resdata = data.data;
            //if ResponseCode is 200
            if (resdata !== null && resdata.ResponseCode === '200') {
                this.setState({
                    SchemeDDL: resdata.ResponseData
                });
            }
        });
    }

    //get Product drop down list 
    GetProductDDL() {

        this.ProductService.GetMappedProductsDDL().then(data => {
            const resdata = data.data;
            //if ResponseCode is 200
            if (resdata !== null && resdata.ResponseCode === '200') {
                this.setState({
                    ProductDDL: resdata.ResponseData
                });
            }
        });
    }

    // get scheme configuration
    GetSchemesConfiguration() {
        this.tblResponse.SortColumn='ValidFrm';
        this.SchemeService.GetPrdctMpping(this.tblResponse).then(data => {
            const resdata = data.data;
            this.setState({updateLoader:true});
       //if ResponseData is not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false                    
                });
            }
        //if ResponseData is null    
             else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false
                });
            }
        });
    }

    // validate form
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;
//to validate each form field with required conditions
        switch (name) {
            case 'SchemeId':
                if (parseInt(value) < 1) {
                    IsValid = false;
                    errors.SchemeId = "Please Select Scheme.";
                } else errors.SchemeId = null;
                break;
            case 'ProductId':
                if (parseInt(value) < 1) {
                    IsValid = false;
                    errors.ProductId = "Please Select Product.";
                } else errors.ProductId = null;
                break;
            default:
                break;
        }
        return IsValid;
    }


    // handle change use for form input
    handleChange(event) {
        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
    }

    // form Reset
    formReset() {
        this.setState({
            SchemeId: 0,
            ProductId: 0
        });

        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }

    // add user
    hideFunc() {
        this.setState({
            visible: false, buttonLabel: 'Submit',
            formHeading: 'Add Scheme Configuration'
        });
        this.formReset();
    }

    // submit form
    submitForm(event) {
        event.preventDefault();

        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            //form not valid
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });
          //form valid
        if (isfrmvalid) {
            const formData = {
                SchemeId: this.state.SchemeId.SchemeId,
                ProductId: this.state.ProductId
            }
            this.setState({updateLoader:false});
            setTimeout(() => {
                this.SchemeService.CreatePrdctMpping(formData).then(data => {

                    const resdata = data.data;
                    //if ResponseCode is 200 success else error or warning message
                    if (resdata !== null && resdata.ResponseCode === '200') {
                        this.refs.child.showSuccess(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader:true
                        });
                        this.formReset();

                        this.GetSchemesConfiguration();
                    } else {
                        this.refs.child.showWarn(resdata.ResponseMessage);
                    }

                    // if (resdata.ResponseCode === '200') {
                    //     this.refs.child.showSuccess(resdata.ResponseMessage);
                    //     this.GetSchemes();
                    // } else {
                    //     this.refs.child.showError(resdata.ResponseMessage);
                    // }
                });
            }, 1000);
        }
    }

    // add checkbox function
    activeTemplate(rowData, column) {
        return (
            <input type="checkbox" name={rowData.SchemeMapingId} checked={rowData.IsActive} onChange={e => { this.actionTemplate(e, rowData) }} />
        )
    }

    // edit form
    actionTemplate(e, rowData) {
        const formData = {
            IsActive: e.target.checked,
            SchemeMapingId: rowData.SchemeMapingId
        }

        setTimeout(() => {
            this.SchemeService.InActiveSchemeConfig(formData).then(data => {
                const resdata = data.data;
                    //if ResponseCode is 200 success else error or warning message

                if (resdata !== null && resdata.ResponseCode === '200') {
                    this.refs.child.showSuccess(resdata.ResponseMessage);
                    this.GetSchemesConfiguration();

                } else {
                    this.refs.child.showWarn(resdata.ResponseMessage);
                }

                // if (resdata.ResponseCode === '200') {
                //     this.refs.child.showSuccess(resdata.ResponseMessage);
                //     this.GetSchemes();
                // } else {
                //     this.refs.child.showError(resdata.ResponseMessage);
                // }
            });
        }, 1000);
    }

    // sort page event
    onSort(event) {
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetSchemesConfiguration();
    }


    // return HTML
    //resolved KREP-102
    render() {
        let header = (
            <div style={{ 'textAlign': 'right' }}>
                <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search" size="30" />
            </div>
        );

        return (
            <>
                <MessageComponent ref="child" />
                <Loaders loader={this.state.updateLoader} />
                <div className="heading">
                    <h1>Scheme Configuration</h1>
                    <Button label="Add Scheme Configuration" icon="pi pi-plus-circle" onClick={this.openDialog} />
                </div>

                <DataTable responsive={true} header={header} globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
                    rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]} totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                    onPage={this.onPage} onSort={this.onSort}>
                    <Column field="SchemeName" header="Scheme Name" sortable={true} />
                    <Column field="FromDate" header="Valid From" filterFunction={this.filterDate} sortable={true} />
                    <Column field="ToDate" header="Valid To" sortable={true} />
                    <Column field="ProductName" header="Product Name" sortable={true} />
                    <Column body={this.activeTemplate} header="Is Active" />
                </DataTable>

                <Dialog className="popup-modal" header={this.state.formHeading} visible={this.state.visible} modal={true} onHide={this.hideFunc}>
                    <form onSubmit={this.submitForm} className="form-padding">
                        <div className="row">
                            <div className="col-md-4 text-right"><label>Scheme<span>*</span>:</label></div>
                            <div className="col-md-8 mb-2">
                                <Dropdown optionLabel="SchemeName" appendTo={document.body} onChange={e => { this.handleChange(e) }} value={this.state.SchemeId} className="form-control" placeholder="Select Scheme" name="SchemeId" options={this.state.SchemeDDL} />
                                {this.state.formError.SchemeId !== null ?
                                    <div className='error'>{this.state.formError.SchemeId}</div> : null}
                            </div>
                            <div className="col-md-4 text-right"><label>Product<span>*</span>:</label></div>
                            <div className="col-md-8 mb-2">
                                <Dropdown onChange={e => { this.handleChange(e) }} appendTo={document.body} value={this.state.ProductId} className="form-control" placeholder="Select Product" name="ProductId" options={this.state.ProductDDL} />
                                {this.state.formError.ProductId !== null ?
                                    <div className='error'>{this.state.formError.ProductId}</div> : null}
                            </div>
                            <div className="col-md-12 text-center"><button type="submit" className="btn btn-primary">{this.state.buttonLabel}</button></div>
                        </div>
                        <div  >
                                <label>Note: Fields marked as (<span style={{ color: 'red' }}>*</span>) are required</label>
                            </div>
                    </form>
                </Dialog>
            </>
        )
    }
}